var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.4 8 5.8 8 4.47 9.6 3.2 8 3.2 7.2 10.4 7.2 10.4 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.6 11.2 9 11.2 7.67 12.8 6.4 11.2 6.4 10.4 13.6 10.4 13.6 11.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.5,2H11V.38A.38.38,0,0,0,10.63,0H9.38A.38.38,0,0,0,9,.38V2H5V.38A.38.38,0,0,0,4.63,0H3.38A.38.38,0,0,0,3,.38V2H1.5A1.5,1.5,0,0,0,0,3.5v11A1.5,1.5,0,0,0,1.5,16h11A1.5,1.5,0,0,0,14,14.5V3.5A1.5,1.5,0,0,0,12.5,2Zm-.19,12.5H1.69a.19.19,0,0,1-.19-.19V5h11v9.31A.19.19,0,0,1,12.31,14.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedule);
export default __webpack_public_path__ + "static/media/icon-schedule.92ba2f43a5c3aad6ee2c69f95f0f147d.svg";
export { ForwardRef as ReactComponent };